import React from "react";
import { Form, Button } from "react-bootstrap";

/**
 * @typedef {Object} FinancialFilterBarProps
 * @property {import("../../../components/dashboard/Sidebar").ReportKey} report
 * @property {string} today
 * @property {string} oneYearAgo
 * @property {string} startDate
 * @property {(s: string) => void} setStartDate
 * @property {string} endDate
 * @property {(s: string) => void} setEndDate
 * @property {boolean} monthly
 * @property {(s: boolean) => void} setMonthly
 * @property {() => void} onRefresh
 */

/**
 * @param {FinancialFilterBarProps} props
 */
export function FinancialFilterBar({
  report,
  today,
  oneYearAgo,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  monthly,
  setMonthly,
  onRefresh,
}) {
  return (
    <div className="pbi-filterbar">
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <i className="bi bi-graph-up-arrow text-info" />
        <span className="fw-semibold me-2">Financial Filters</span>

        <div className="d-flex align-items-center gap-2">
          <Form.Control
            type="date"
            size="sm"
            style={{ width: 150 }}
            value={startDate}
            min={oneYearAgo}
            max={endDate || today}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <span className="text-muted small">to</span>
          <Form.Control
            type="date"
            size="sm"
            style={{ width: 150 }}
            value={endDate}
            min={startDate || oneYearAgo}
            max={today}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <Form.Check
            type="switch"
            id="financial-monthly"
            className="mb-1"
            label="Month-by-month comparison"
            checked={monthly}
            onChange={(e) => setMonthly(e.target.checked)}
          />
        </div>
      </div>

      <div className="d-flex align-items-center gap-2">
        <Button size="sm" variant="outline-secondary" onClick={onRefresh}>
          <i className="bi bi-arrow-clockwise" />
        </Button>
        <Button size="sm" variant="outline-secondary">
          <i className="bi bi-download me-1" />
          Export
        </Button>
      </div>
    </div>
  );
}
